export interface LogLevelSetting {
    logTriggerRequestAndResponse?: boolean;
    logLevel?: LogLevel;
    historyStorageDays?: number;
    debugExpiresAt?: string | null;
    setDebugeExpiresInSeconds?: number;
}
export type LogLevel = "Info" | "Error" | "Debug" | "ErrorsWithoutStepLogging" | null;
 // ACC-7751: Only Errors = lowest logging, Info = Default logging, Debug = Log everything
export const LogLevelIndices: LogLevel[] = ["Error", "Info", "Debug"];
export enum LogLevelTimeLimit { Off = 0, Minutes15 = 900, Minutes60 = 3600, Hours4 = 14400, Hours24 = 86400 } // Seconds

export interface AgentGroupLogLevelSetting {
    agentGroupSettings: LogLevelSetting;
    processSettings?: LogLevelSetting;
    maxHistoryStorageDaysForProcesses: number;
    maxHistoryStorageDaysForAgentGroups: number;
}

export interface LogLevelDialogState {
    showDialog: boolean;
    isAgentGroupSetting?: boolean;
    environmentName?: string;
    allowLogEverything?: boolean;
    processIds?: number[];
    loadedSettings?: AgentGroupLogLevelSetting;
    currentSettings?: LogLevelSetting;
    selectedProcessesSupportLogLevelErrorsWithDisabledPromotedResultLogging?: boolean | null;
}
